import { useRef } from "react";
import css from "../../Assets/Styles/Home/testimonials.module.css";
import TestimonialsCard from "./TestimonialsCard";
import Fade from "react-reveal/Fade";
import emailjs from "@emailjs/browser";
import { toast } from "react-toastify";

const Testimonials = () => {
  const form = useRef();
  const emailSendHandler = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_0k53cwo",
        "template_db1oh5l",
        form.current,
        "1oWW5ARNXiY7mtaiC"
      )
      .then(
        (result) => {
          toast.success("Thank you, we will contact you within 24 hours!", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        },
        (error) => {
          toast.error("Sorry, try again!", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        }
      );

    e.target.reset();
  };
  return (
    <Fade bottom>
      {" "}
      <section className={`${css.testimonials_container}`}>
        <div
          className={`2xl:max-w-[1320px] font-roboto max-xl:max-w-[1150px]  mx-auto flex justify-between items-center  flex-col max-lg:flex-row     gap-20 `}
        >
          <TestimonialsCard />

          <div>
            <div
              className={`${css.formCard} max-sm:x-[99px] p-10 max-sm:pt-[88px] font-fira w-full max-sm:w-[560px] h-[720px]`}
            >
              <h3 className="font-semibold text-[13px] mb-[16px]">
                <span className="text-linear-gradient"> GET A FREE QUOTE</span>
              </h3>
              <h2 className="text-[42px] text-[#0D1C37]  font-bold leading-[53px] mb-8">
                GET A FREE QUOTE
              </h2>
              <form ref={form} onSubmit={emailSendHandler}>
                <input
                  className="w-full mb-[13px] py-4 px-7 outline-none text-[#6A6D7A] text-base"
                  type="text"
                  placeholder="Full Name:"
                  required
                  name="full_name"
                />
                <input
                  className="w-full mb-[13px] py-4 px-7 outline-none text-[#6A6D7A] text-base"
                  type="email"
                  placeholder="Email Address:"
                  required
                  name="email"
                />
                <select
                  className="w-full mb-[13px] py-4 px-7 outline-none text-[#6A6D7A] text-base"
                  id="services"
                  name="services"
                  required
                >
                  <option value="" selected disabled hidden>
                    Choose here
                  </option>
                  <option value="webDevelopment">Web Development</option>
                  <option value="appDevelopment">App Development</option>
                  <option value="graphicDesign">Graphic Design</option>
                  <option value="digitalMarketing">Digital Marketing</option>
                </select>
                <textarea
                  required
                  name="message"
                  className="w-full mb-[13px] py-4 px-7 h-[140px] outline-none text-[#6A6D7A] text-base"
                  placeholder="Write Message..."
                ></textarea>
                <button className="custom_button ">
                  {" "}
                  Submit Now
                  <i className="fa-solid fa-arrow-right ml-2"></i>
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>
    </Fade>
  );
};

export default Testimonials;
